<script setup lang="ts">
defineOptions({
  name: 'ReferenzenPage'
})
</script>

<template>
  <div>
    <Head>
      <Title>Referenzen</Title>
      <Meta
        name="description"
        content="Referenzprojekte von johnsenpartner. architekten – Wohn- und Gewerbebau in Solingen und Umgebung."
      />
    </Head>
    <ReferenzenIntro />
    <ReferenzenGallery />
  </div>
</template>
